import { apiPost } from '../ApiClient';

/**
 * Fetch a server-authoritative quote for the current POS cart.
 * The backend applies ERPNext Pricing Rules / Promotional Schemes,
 * taxes, rounding, and optional loyalty redemption.
 */
export async function fetchPriceQuote(payload) {
  const res = await apiPost('method/custom_api.pos_retail.price_quote', payload);
  return res?.message || res;
}

/**
 * Fetch loyalty balance/redemption metadata for a customer.
 */
export async function fetchLoyaltyInfo({ customer, loyaltyProgram, company }) {
  const res = await apiPost('method/custom_api.pos_retail.get_loyalty_info', {
    customer,
    loyalty_program: loyaltyProgram,
    company,
  });
  return res?.message || res;
}
